import dayjs from 'dayjs';

const currencyFormatter = new Intl.NumberFormat('en-PK', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

export const money = (value: number | null | undefined) =>
  value === null || value === undefined ? '—' : currencyFormatter.format(value);

export const pkr = (value: number | null | undefined) =>
  value === null || value === undefined ? '—' : `PKR ${currencyFormatter.format(value)}`;

export const date = (value: string | null | undefined) =>
  value ? dayjs(value).format('DD MMM YYYY') : '—';

export const dateTime = (value: string | null | undefined) =>
  value ? dayjs(value).format('DD MMM YYYY HH:mm') : '—';

export const apiDate = (value: dayjs.Dayjs | null | undefined) =>
  value ? value.format('YYYY-MM-DD') : undefined;

export const percent = (value: number) => `${value.toFixed(2)}%`;
